<template>
  <div>
    <h2 class="pt-3 pt-sm-4">{{ heading }}</h2>
    <slot></slot>
    <StepProgressIndicator class="py-4 px-5 mx-sm-5" :currentStep="currentStep" :numberOfSteps="totalSteps">
    </StepProgressIndicator>
    <mobialis-button
      @click="next()"
      class="mt-4 mb-4"
      data-cy="continue"
      v-av-analytics-cta-interaction="{ elementText: $t('message.common.continue'), eventActionResult: 'open' }"
      >{{ $t('message.common.continue') }}</mobialis-button
    >
    <DropDownCard v-for="(step, index) in steps" :togglesOnDesktop="true" :key="index" class="mb-3 mt-3">
      <template v-slot:header>
        <div class="clearfix">
          <span class="p m-0">
            {{ step.name }}
            <span v-if="currentStep > index + 1" class="primary-fill-svg check-img">
              <inline-svg class="mr-2 mb-1" :src="require('@/assets/fa/check-blue.svg')" alt="" />
            </span>
          </span>
          <span class="float-right p m-0 small">
            <img class="clock-img" src="@/assets/clock-grey.svg" alt="" />
            {{ step.time }}
          </span>
        </div>
        <h3 class="mt-1 mb-0">{{ step.heading }}</h3>
      </template>
      <template v-slot:dropdown>
        <p class="mb-0 mt-0 pt-2">
          {{
            $t(`message.eCommerceV2.personalizedPayment.stepCards.step${index + 1}.msg`, {
              creditProvider: getDefaultCreditDataSourceCAName.niceName,
            })
          }}
        </p>
        <p class="mb-0 mt-3" v-if="step.msg2">
          <b>{{ step.msg2 }}</b>
        </p>
      </template>
      <template v-slot:hideLabel>
        <span class="small text-dark">{{ $t('message.eCommerceV2.personalizedPayment.stepCards.hideDetails') }}</span>
      </template>
      <template v-slot:showLabel>
        <span class="small text-dark">{{ $t('message.eCommerceV2.personalizedPayment.stepCards.showDetails') }}</span>
      </template>
    </DropDownCard>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import StepProgressIndicator from '@/components/StepProgressIndicator.vue';
import DropDownCard from '@/components/DropDownCard.vue';

export default {
  name: 'PersonalizedPaymentSteps',
  components: {
    StepProgressIndicator,
    DropDownCard,
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      totalSteps: 3,
      steps: [
        this.$t('message.eCommerceV2.personalizedPayment.stepCards.step1'),
        this.$t('message.eCommerceV2.personalizedPayment.stepCards.step2'),
        this.$t('message.eCommerceV2.personalizedPayment.stepCards.step3'),
      ],
    };
  },
  computed: {
    ...mapGetters('ecommerceV2', ['getDefaultCreditDataSourceCAName']),
  },
  methods: {
    next() {
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';
h3 {
  color: $primary;
}
.clock-img {
  margin: 0 2px 2px 0;
}
.check-img {
  margin: 0 0 2px 2px;
}
</style>
